import { render, staticRenderFns } from "./MobileOrders.vue?vue&type=template&id=7f5867aa"
import script from "./MobileOrders.vue?vue&type=script&lang=js"
export * from "./MobileOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports